import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import css from '@src/styles/components/tooltip.scss';

export default class Tooltip extends React.Component {

    constructor(props) {

        // @todo fix overlay inner other fixed/absolute element

        super(props);

        this.nodes = {
            tooltip: null,
            helper: null,
        };
    }

    static get propTypes() {

        return {
            className: PropTypes.string,
            children: PropTypes.any,
        };
    }

    render() {

        if (!this.props.children)
            return null;

        return (
            <div
                ref={(node) => { this.nodes.tooltip = node; }}
                className={ `${css.tooltip} ${this.props.className ?? ''}` }
                onMouseEnter={ () => this.fixTooltipPosition() }
                onClick={ () => this.toggleTooltip() }>

                <div className={ css.tooltipToggle }>
                    <span className={ style('text-medium') }>i</span>
                </div>
                <div className={ css.tooltipTextHelper }></div>
                { this.renderTooltipText() }

            </div>
        );
    }

    renderTooltipText() {

        const children = this.props.children;
        if (typeof (children) == 'object')
            return <div className={ css.tooltipText }>{ children }</div>;

        return <div className={ css.tooltipText } dangerouslySetInnerHTML={{ __html: children }}></div>;
    }

    getTextElement() {

        if (this.textElement == undefined)
            this.textElement = this.nodes.tooltip.querySelector(`.${css.tooltipText}`);

        return this.textElement;
    }

    fixTooltipPosition() {

        const
            textElement = this.getTextElement();

        if (!this.nodes.tooltip || !textElement)
            return;

        const
            { top, bottom } = textElement.getBoundingClientRect(),
            documentBottom = window.innerHeight + window.scrollY;

        if (top < 0)
            this.nodes.tooltip.classList.add(css.tooltipToDownType);

        if (bottom > documentBottom)
            this.nodes.tooltip.classList.remove(css.tooltipToDownType);
    }

    toggleTooltip() {

        this.nodes.tooltip.classList.toggle(css.active);
    }

}